import { useApiClient } from '../hooks/useApiClient'

export function useMatchOptionsForInvoice(
  params: { invoice_id: string },
  options?: {
    enabled?: boolean
  }
) {
  const $api = useApiClient()

  return $api.useQuery(
    'post',
    '/supplier_rec/match/options_for_invoice',
    {
      params: {
        query: params,
      },
    },
    options
  )
}
